/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-11T09:36:43.293
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportFinancialStorageContract,
	getReportFinancialStorageContractCreateInit,
	getReportFinancialStorageContractEditInit,
	getReportFinancialStorageContractView,
	deleteReportFinancialStorageContract
} from '@api/report/ReportFinancialStorageContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportFinancialStorageContractCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialStorageContractCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportFinancialStorageContractEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialStorageContractEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportFinancialStorageContract({}, ReportFinancialStorageContract) {
			return new Promise((resolve, reject) => {
				saveReportFinancialStorageContract(ReportFinancialStorageContract)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportFinancialStorageContractView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialStorageContractView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportFinancialStorageContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialStorageContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
